// extracted by mini-css-extract-plugin
export default {"switch":"Switch--switch--bm+NB","inlineTooltip":"Switch--inlineTooltip--pgIqH"};